import React from 'react';
import { Button, Header, Label, Table } from 'semantic-ui-react';

import { escribirMonto } from '../utilidades';
import AccionesTablaCobrosCalculados from './Componentes/AccionesTablaCobrosCalculados';
import ModalIngresarPagoCobroCalculado, {
    ModalIngresarPagoCobroCalculadoProps,
} from './ModalIngresarPagoCobroCalculado';
import { CobroCalculado, PagoCobroCalculado } from './tipos';

export type EstadoCobroCalculado = 'POR_PAGAR' | 'PAGADA' | 'ABONADA';

interface State {
    ModalIngresarPagoCobroCalculadoAbierto: boolean;
    propsModal?: ModalIngresarPagoCobroCalculadoProps;
}
interface TablaCobrosCalculadosProps {
    cobrosCalculados: Array<CobroCalculado>;
    idPlanDePago: string;
    nombreCompletoApoderado: string;
    rutPasaporte: string;
    fechaDeMatricula: string;
    alRealizarPago(): void;
    alEditarPago(): void;
}

export class TablaCobrosCalculados extends React.Component<TablaCobrosCalculadosProps, State> {
    public state: State = {
        ModalIngresarPagoCobroCalculadoAbierto: false,
    };
    public render() {
        const {
            cobrosCalculados,
            idPlanDePago,
            nombreCompletoApoderado,
            rutPasaporte,
            alRealizarPago,
            alEditarPago,
            fechaDeMatricula,
        } = this.props;

        return (
            <div>
                <Header as='h4'>Otros cobros</Header>
                <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell textAlign='center'>Tipo</Table.HeaderCell>
                            <Table.HeaderCell textAlign='center'>
                                Fecha de
                                <br />
                                vencimiento
                            </Table.HeaderCell>
                            <Table.HeaderCell textAlign='center'>Monto</Table.HeaderCell>
                            <Table.HeaderCell textAlign='center'>Pagado</Table.HeaderCell>
                            <Table.HeaderCell textAlign='center'>Deuda</Table.HeaderCell>
                            <Table.HeaderCell textAlign='center'>Estado</Table.HeaderCell>
                            <Table.HeaderCell />
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {cobrosCalculados.map(cobroCalculado =>
                            cobroCalculado.monto > 0 ? (
                                <FilaCobrosCalculados
                                    key={`${cobroCalculado.tipo}${cobroCalculado.monto}`}
                                    idPlanDePago={idPlanDePago}
                                    fechaDeMatricula={fechaDeMatricula}
                                    {...cobroCalculado}
                                    alPresionarIngresarPago={() => {
                                        this.setState({
                                            propsModal: {
                                                tipoDeCobroCalculado: cobroCalculado.tipo,
                                                montoInicial: cobroCalculado.monto,
                                                deudaRestante: cobroCalculado.montoRestante,
                                                modalAbierto: true,
                                                idPlanDePago,
                                                nombreCompletoApoderado,
                                                rutPasaporte,
                                                alIntentarCerrar: this.cerrarModal,
                                                alRealizarPago: () => {
                                                    alRealizarPago();
                                                    this.cerrarModal();
                                                },
                                            },
                                        });
                                    }}
                                    alEditarPago={alEditarPago}
                                />
                            ) : (
                                ''
                            ),
                        )}
                    </Table.Body>
                </Table>
                {this.state.propsModal !== undefined ? (
                    <ModalIngresarPagoCobroCalculado {...this.state.propsModal} />
                ) : null}
            </div>
        );
    }
    public cerrarModal = () => {
        this.setState({ propsModal: undefined });
    };
}

interface FilaCobrosCalculadosProps {
    idPlanDePago: string;
    tipo: 'gasto-notarial' | 'abono-inicial';
    estado: EstadoCobroCalculado;
    monto: number;
    montoPagado: number;
    montoRestante: number;
    fecha?: string;
    fechaDeMatricula: string;
    pagos: Array<PagoCobroCalculado>;
    alPresionarIngresarPago(): void;
    alEditarPago(): void;
}

const FilaCobrosCalculados: React.FunctionComponent<FilaCobrosCalculadosProps> = props => {
    const {
        idPlanDePago,
        tipo,
        monto,
        montoPagado,
        montoRestante,
        pagos,
        alPresionarIngresarPago,
        alEditarPago,
        estado,
        fecha,
        fechaDeMatricula,
    } = props;

    const tipoDeCobroCalculado = tipo === 'gasto-notarial' ? 'Gasto notarial' : 'Abono inicial';
    return (
        <Table.Row key={`${monto}${tipo}`}>
            <Table.Cell textAlign='center'>{tipoDeCobroCalculado}</Table.Cell>
            <Table.Cell textAlign='center'>
                {escribirFecha(tipo === 'gasto-notarial' ? fecha! : fechaDeMatricula)}
            </Table.Cell>
            <Table.Cell textAlign='center'>{escribirMonto(monto)}</Table.Cell>
            <Table.Cell textAlign='center'>{escribirMonto(montoPagado)}</Table.Cell>
            <Table.Cell textAlign='center'>{escribirMonto(montoRestante)}</Table.Cell>
            <Table.Cell textAlign='center'>{escribirEstadoCobroCalculado(estado)}</Table.Cell>
            <Table.Cell textAlign='center'>
                <Button
                    size='tiny'
                    content='Ingresar pago'
                    onClick={alPresionarIngresarPago}
                    disabled={estado === 'PAGADA'}
                />
                <AccionesTablaCobrosCalculados
                    idPlanDePago={idPlanDePago}
                    estadoCobroCalculado={estado}
                    pagos={pagos}
                    alEditarPago={alEditarPago}
                />
            </Table.Cell>
        </Table.Row>
    );
};

const estadosCobrosCalculados: Record<EstadoCobroCalculado, React.ReactNode> = {
    PAGADA: <Label color='green' content='Pagada' />,
    ABONADA: <Label color='yellow' content='Abonada' />,
    POR_PAGAR: null,
};

function escribirEstadoCobroCalculado(estado: EstadoCobroCalculado) {
    return estadosCobrosCalculados[estado];
}

function escribirFecha(fecha: string) {
    const [año, mes, dia] = fecha.split('-');
    return `${dia}-${mes}-${año}`;
}

export default TablaCobrosCalculados;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/TablaCobrosCalculados.tsx